import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { rolesList, serviceRolesList, settingRolesList } from '@/helpers/roles';

import Setting from './setting';
import Service from './service';
import RIF from './rif';
import Dashboard from './dashboard';
import Login from './authentication';
import Analytics from './analytics';
import PermissionRoute from '../components/layouts/permission-route';
import { AuthLayout } from '../components/layouts';

const SecurityRoute = () => <AuthLayout />;

const Modules = () => (
  <BrowserRouter>
    <Routes>
      <Route element={<Login />} path="auth/*" />
      <Route element={<SecurityRoute />}>
        <Route element={<Dashboard />} index />
        <Route element={<PermissionRoute allowedRoles={rolesList} />}>
          <Route element={<Analytics />} path="analytics/*" />
        </Route>
        <Route element={<PermissionRoute allowedRoles={serviceRolesList} />}>
          <Route element={<Service />} path="service/*" />
        </Route>
        <Route element={<PermissionRoute allowedRoles={settingRolesList} />}>
          <Route element={<Setting />} path="setting/*" />
        </Route>
        <Route element={<RIF />} path="rif/*" />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default Modules;
